import React from "react";
/* data import */
import { doctorData, doctorImages } from "../data/doctorData";

const DoctorsThumbsWrapper = ({ handleDoctorInfoClick }) => {
  return (
    <div className="doctors-thumbs-wrapper">
      <div>
        <div className="doctors-thumbs">
          {doctorData.length > 0 &&
            doctorData.map((val, i) => (
              <div
                key={i}
                className="doctor-thumb"
                onClick={() => handleDoctorInfoClick(val.id)}
              >
                <div className="doctor-thumb-img">
                  <img src={doctorImages[val.imageLink]} alt={val.name} />
                </div>
                <div className="doctor-thumb-name">{val.name}</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DoctorsThumbsWrapper;
